import { useState } from 'react';

interface ProductGalleryProps {
  productName: string;
  image: string;
  productId: number;
}

export default function ProductGallery({ productName, image, productId }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  // Generate 3 different angle images per product using different seq
  const baseSeq = productId * 100;
  const galleryImages = [
    image,
    image.replace(/seq=\d+/, `seq=${baseSeq + 1}`),
    image.replace(/seq=\d+/, `seq=${baseSeq + 2}`),
  ];

  const imageQueries = [
    `product front view on soft cream white background minimalist professional lighting`,
    `product side angle view on soft cream white background minimalist professional lighting`,
    `product detail close up view on soft cream white background minimalist professional lighting`,
  ];

  const finalImages = galleryImages.map((img, i) => {
    if (i === 0) return img;
    // Replace query part for different angles
    const url = new URL(img);
    const params = new URLSearchParams(url.search);
    params.set('query', imageQueries[i]);
    return `${url.origin}${url.pathname}?${params.toString()}`;
  });

  return (
    <div>
      {/* 主圖 */}
      <div className="rounded-2xl overflow-hidden h-72 md:h-[500px] bg-[#FAF8F5] relative group">
        <img
          src={finalImages[activeIndex]}
          alt={`${productName} - ${activeIndex === 0 ? '正面' : activeIndex === 1 ? '側面' : '細節'}`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        {/* 圖片放大提示 */}
        <div className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-zoom-in-line text-[#1B3D2A]" />
          </div>
        </div>
        {/* 圖片計數器 */}
        <div className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs text-[#5A6B5A] font-medium">
          {activeIndex + 1} / {finalImages.length}
        </div>
      </div>

      {/* 縮圖 */}
      <div className="mt-4 flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory">
        {finalImages.map((img, idx) => (
          <button
            type="button"
            key={idx}
            onClick={() => setActiveIndex(idx)}
            className={`w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden flex-shrink-0 border-2 transition-all duration-300 snap-start ${
              idx === activeIndex
                ? 'border-[#1B3D2A] ring-2 ring-[#1B3D2A]/10'
                : 'border-[#E8E0D6] hover:border-[#D4A574]'
            }`}
          >
            <img
              src={img}
              alt={`${productName} 縮圖 ${idx + 1}`}
              className="w-full h-full object-cover object-top"
            />
          </button>
        ))}
      </div>
    </div>
  );
}